import moment from "moment";

//#region 聚合字段
type AggType = 'count' | 'doubleMax' | 'doubleMin' | 'doubleSum' | 'longMax' | 'longMin' | 'longSum' | 'thetaSketch'
export class Aggregator {
  constructor(type: AggType, name: string, fieldName: string, size?: number) {
    this.type = type
    this.name = name
    this.fieldName = fieldName
    this.size = size
  }
  /** 聚合类型 */
  type: AggType
  /** 别名 */
  name: string
  /** 字段名 */
  fieldName: string
  /** 长度 */
  size?: number
}
export const CALCWEIGHT = new Aggregator('doubleSum', 'calcWeight', 'calcWeight',)
export const GOODSWEIGHT = new Aggregator('doubleSum', 'goodsWeight', 'goodsWeight')
export const GOODSAsCALC = new Aggregator('doubleSum', 'calcWeight', 'goodsWeight')
export const GOODSVOLUME = new Aggregator('doubleSum', 'goodsVolume', 'goodsVolume')
export const TICKET = new Aggregator('longSum', 'ticket', 'ticket')
export const PIECE = new Aggregator('longSum', 'piece', 'piece')
export const CountTicket = new Aggregator('count', 'ticket', 'ticket')
export const SumTotalPeriod = new Aggregator("doubleSum", "totalPeriod", "totalPeriod")
export const CountAll = new Aggregator('count', 'count', '*')
export const CountAllArea = new Aggregator('count', 'count', 'ticket')
export const SKETCHTICKET = new Aggregator('thetaSketch', 'SketchTicket', 'waybillNo')
export const SKETCHTICKET2 = new Aggregator('thetaSketch', 'ticket', 'waybillNo')
export const SKETCHTICKET_SIZE = (m: number = 14) => new Aggregator('thetaSketch', 'SketchTicket', 'waybillNo', Math.pow(2, m))

export const aggreFieldAs = {
  ticket: TICKET,
  piece: PIECE,
  calcWeight: CALCWEIGHT,
  goodsWeight: GOODSWEIGHT,
  goodsVolume: GOODSVOLUME,
}
//#endregion

export const getProduct = (value) => {
  switch (value) {
    case 1:
      return { productType: '定时达' }
    case 2:
      return { superiorityProduct: '是' }
    case 3:
      return { lengthOfTime: '次日达' }
    case 4:
      return { lengthOfTime: '隔日达' }
  }
  return null
}

export enum ProductE {
  全部 = 0,
  定时达,
  优势业务,
  次日达,
  隔日达,
}


export type DataBase = (
  /** 实际表 */
  'actual_load_unload_result' |
  /** 计划表 */
  'route_plan_result' |
  /** 计划表stream */
  'route_plan_result_stream' |
  'actual_load_unload_result_stream' |
  'actual_forecast_result' |
  'route_plan_optimal_result' |
  'actual_time_consume_result' |
  "delivery_dis_accord_result"  |
  'static_actual_time_consume_result' | 
  'static_actual_time_consume_result_sat'
)




/** 若超过当天12点就算当前12点到第二天12点 */
export function getToDay() {
  const currentTime = new Date().valueOf();
  const currentTime12 = moment(moment(currentTime).format('YYYY-MM-DD 12:00:00')).valueOf() // 当天12点
  if (currentTime > currentTime12) {
    return [
      moment(currentTime).format('YYYY-MM-DD 12:00:00'),
      moment(currentTime).add(1, 'days').format('YYYY-MM-DD 12:00:00')
    ]
  } else {
    return [
      moment(currentTime).add(-1, 'days').format('YYYY-MM-DD 12:00:00'),
      moment(currentTime).format('YYYY-MM-DD 12:00:00')
    ]
  }
}
